import { render, staticRenderFns } from "./AxLayout.vue?vue&type=template&id=23cd5c24&scoped=true"
import script from "./AxLayout.vue?vue&type=script&lang=ts"
export * from "./AxLayout.vue?vue&type=script&lang=ts"
import style0 from "./AxLayout.vue?vue&type=style&index=0&id=23cd5c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd5c24",
  null
  
)

export default component.exports